import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IBulkProductsDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IBulkProductsDto
>("stores.products.bulkCreate");

export const bulkCreate = {
  ...postApis,
};
